import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { userProfiles } from "../../redux/slices/UserProfilesSlice";
import NotAllowed from "../../components/NotAllowed/NotAllowed";
import MaterialRequestForm from "../../components/Forms/MaterialRequestForms/MaterialRequestForm";

function MaterialRequest() {
  const reduxUserProfiles = useSelector(userProfiles);

  const isLoading = reduxUserProfiles?.isLoading;
  const hasContracts =
    reduxUserProfiles?.data && reduxUserProfiles.data.length > 0;

  if (isLoading || !hasContracts) {
    return (
      <NotAllowed
        isUserAllowed={hasContracts}
        isLoading={isLoading}
        loadingMessage="Cargando contratos..."
        notAllowedMessage={
          <>
            <h2>No ha sido posible recuperar los contratos del cliente.</h2>
            <h2>
              Póngase en contacto con su comercial de la cuenta/operaciones de
              Correos Frio.
            </h2>
          </>
        }
      />
    );
  }

  return (
    <div className="MaterialRequest">
      <h2>Petición de material</h2>

      <MaterialRequestForm reduxUserProfiles={reduxUserProfiles} />
    </div>
  );
}

export default MaterialRequest;
